"use client";

import { useQuery } from "@apollo/client/react";
import Link from "next/link";
import React from "react";
import { LuScrollText } from "react-icons/lu";

import CoinPriceFormatter from "@/components/shared/coin-price-formatter";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { DaoCoinStatsDocument } from "@/graphql/codegen/graphql";
import {
  FOCUS_LAUNCH_DATE,
  LAUCHING_TOKEN_DOC_URL,
  TRADE_EXCLUDED_PUBLIC_KEYS,
} from "@/utils/constants";

export const TotalTokens = () => {
  const { data, loading } = useQuery(DaoCoinStatsDocument, {
    fetchPolicy: "network-only",
    variables: {
      filter: {
        coinUsername: {
          startsWithInsensitive: "",
          notEqualTo: "",
        },
        coinPublicKey: {
          notIn: TRADE_EXCLUDED_PUBLIC_KEYS,
        },
        or: [
          {
            tokenAmmCreatedAt: {
              isNull: true,
            },
          },
          {
            tokenAmmCreatedAt: {
              greaterThan: FOCUS_LAUNCH_DATE,
            },
          },
        ],
      },
    },
  });

  return (
    <div
      className="
        unforce-radius flex w-full items-center justify-between border-b px-4
        py-1
        lg:px-6
      "
    >
      <div className="w-full">
        {loading || !data ? (
          <Skeleton className="h-6 w-40" />
        ) : (
          <div className="flex w-full items-center gap-1 text-xs text-muted">
            Total Tokens:
            <span className="font-shadow-green font-mono text-emerald-400">
              <CoinPriceFormatter
                price={data.daoCoinStats?.totalCount || 0}
                isUsd={false}
              />
            </span>
          </div>
        )}
      </div>
      <Link href={LAUCHING_TOKEN_DOC_URL} target="_blank" className="w-full">
        <Button
          className="ml-auto flex items-center gap-x-2 px-0 text-muted"
          variant="link"
        >
          <LuScrollText className="text-sm" />
          <span className="text-xs">
            Learn More{" "}
            <span
              className="
                hidden
                md:inline
              "
            >
              about Launching Tokens
            </span>
          </span>
        </Button>
      </Link>
    </div>
  );
};
